import { FormattedMessage } from 'react-intl';
import { Image } from '@/components/Image';

export const NothingCard = ({ className = '' }: { className?: string }) => {
  return (
    <div
      className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col gap-4 justify-center items-center text-[#808080] text-[16px] font-medium ${className}`}
    >
      <Image src="/icons/out-of-stock.svg" alt="out-of-stock" className="w-[275px] h-[110px]" width={275} height={110} />
      <span>
        <FormattedMessage id="out_of_stock" defaultMessage="Photocards are currently out of stock." />
      </span>
    </div>
  );
};
